import React from "react";
import {
  Container,
  CustomTextAreaInput,
  InputContainer,
  Label,
} from "./styles";

export default function TextAreaInput({
  name,
  label,
  placeholder,
  value,
  onChange,
  ...props
}) {
  return (
    <Container>
      <Label htmlFor={name}>{label}</Label>
      <InputContainer>
        <CustomTextAreaInput
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...props}
        />
      </InputContainer>
    </Container>
  );
}
